import { render } from "./PermissionTable.vue?vue&type=template&id=3b4482fe"
import script from "./PermissionTable.vue?vue&type=script&lang=js"
export * from "./PermissionTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/PermissionTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b4482fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b4482fe', __exports__)) {
    api.reload('3b4482fe', __exports__)
  }
  
  module.hot.accept("./PermissionTable.vue?vue&type=template&id=3b4482fe", () => {
    api.rerender('3b4482fe', render)
  })

}


export default __exports__